/**
 * Mock Data for Clients Charts and Tables
 *
 * Contains mock data used in various client-related chart and table components
 */

import { HorizontalBarChartData } from '../Common/HorizontalBarChart.tsx/HorizontalBarChart';

// Data structure for top clients
export interface Client {
    ranking: number;
    name: string;
    location: string;
    visits: number;
    sales: number;
}

// Data structure for cohort analysis
export interface CohortData {
    cohortMonth: string;
    newClients: number;
    retentionByMonth: number[];
    isTotal?: boolean;
}

// Mock data for top clients table
export const clientsData: Client[] = [
    { ranking: 1, name: 'John Doe', location: 'NY', visits: 90, sales: 23567 },
    { ranking: 2, name: 'Alex Doe', location: 'CA', visits: 82, sales: 18920 },
    { ranking: 3, name: 'Alex Johnson', location: 'IL', visits: 75, sales: 31450 },
    { ranking: 4, name: 'Fabiola Castillo', location: 'TX', visits: 66, sales: 25300 },
    { ranking: 5, name: 'Maria Garcia', location: 'AZ', visits: 58, sales: 19750 },
    { ranking: 6, name: 'Mary Doe', location: 'PA', visits: 55, sales: 45000 }
];

// Mock data for dog breed chart
export const dogBreedData: HorizontalBarChartData[] = [
    {
        name: 'Poodle',
        currentValue: 750,
        previousValue: 652,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024'
    },
    {
        name: 'Golden Retriever',
        currentValue: 710,
        previousValue: 617,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024'
    },
    {
        name: 'Yorkshire Terrier',
        currentValue: 690,
        previousValue: 724,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024'
    },
    {
        name: 'Schnauzer',
        currentValue: 610,
        previousValue: 581,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024'
    },
    {
        name: 'Beagle',
        currentValue: 567,
        previousValue: 567,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024'
    },
    {
        name: 'Cocker Spaniel',
        currentValue: 451,
        previousValue: 501,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024'
    },
    {
        name: 'Shih Tzu',
        currentValue: 398,
        previousValue: 362,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024'
    }
];

// Mock data for cohort analysis table
export const cohortData: CohortData[] = [
    {
        cohortMonth: 'All cohorts',
        newClients: 4811,
        retentionByMonth: [87, 88, 91, 88, 87, 86, 89, 91, 90, 91],
        isTotal: true
    },
    {
        cohortMonth: 'Sep 2024',
        newClients: 550,
        retentionByMonth: [92, 87, 83, 79, 88, 91, 85, 76, 89, 94]
    },
    {
        cohortMonth: 'Oct 2024',
        newClients: 460,
        retentionByMonth: [78, 95, 89, 84, 91, 87, 93, 81, 88, 90]
    },
    {
        cohortMonth: 'Nov 2024',
        newClients: 620,
        retentionByMonth: [82, 80, 86, 92, 77, 85, 89, 83, 91, 88]
    },
    {
        cohortMonth: 'Dec 2024',
        newClients: 671,
        retentionByMonth: [75, 88, 91, 84, 79, 93, 87, 82, 90, 85]
    },
    {
        cohortMonth: 'Jan 2025',
        newClients: 479,
        retentionByMonth: [89, 91, 86, 94, 82, 88, 77, 90, 85, 92]
    },
    {
        cohortMonth: 'Feb 2024',
        newClients: 534,
        retentionByMonth: [91, 84, 88, 76, 93, 87, 81, 89, 85, 90]
    },
    {
        cohortMonth: 'Mar 2024',
        newClients: 578,
        retentionByMonth: [83, 89, 92, 85, 78, 91, 86, 88, 94, 80]
    },
    {
        cohortMonth: 'Apr 2024',
        newClients: 1450,
        retentionByMonth: [78, 93, 87, 90, 84, 89, 92, 86, 81, 88]
    }
];
